export const QUANTITY_SELECTOR_ID = 'quantity-selector-id'
